import resellersModule from "../resellersModule.js";

// Import highcharts and data module so it is included on the page.
import Highcharts from 'highcharts'; 
import * as Highcharts_data from 'highcharts/modules/data';

function highchartsService(resellersConstants, $timeout, $q) {
    "ngInject";
    
    const toHighChartsData = function (dataPoints) {
        return dataPoints.reverse().map(function (dataPoint) {
            var date = new Date(dataPoint.date);
            return date.getTime() + resellersConstants.highCharts.itemDelimiter + dataPoint.value;
        }).join(resellersConstants.highCharts.lineDelimiter);
    };

    return {
        getDateMinusDays: function (days) {
            var d = new Date();
            d.setDate(d.getDate() - days);
            return d.getTime();
        },

        toHighChartsData: function (dataPoints) {
            return {
                csv: `col${resellersConstants.highCharts.itemDelimiter}row${resellersConstants.highCharts.lineDelimiter}` + toHighChartsData(dataPoints) + resellersConstants.highCharts.lineDelimiter,
                itemDelimiter: resellersConstants.highCharts.itemDelimiter,
                lineDelimiter: resellersConstants.highCharts.lineDelimiter
            };;
        }
    };
}

resellersModule.factory("highchartsService", highchartsService);
export default highchartsService;